// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__Rg6GZ","Icon":"Search_Icon__nTkmv"};